import { css } from "@/theme";

export const modalStyles = {
  container_left: css`
    width: 100%;
    height: 100%;
    border-right: none;
    position: relative;
    & .MuiTypography-h3 {
      padding: 1.5rem;
    }
  `,
  tab: css`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0.5rem 1.5rem;

    &:hover,
    &:focus,
    &:active {
      backgroundcolor: transparent !important;
    }
  `,
  active_tab: css`
    background-color: rgba(0, 0, 0, 0.05);
  `,
  tab_title: css`
    display: inline-flex;
    color: #161b32 !important;
  `,
  circle: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    margin-right: 10px;
    padding: 22px;
    border: 2px dotted grey;
    background: transparent;
  `,
  active_circle: css`
    background: black;
    border: 2px solid black;
    color: white;
  `,
  tabs: css`
    margin-bottom: 0.5rem;

    & .MuiTabs-indicator {
      display: none;
    }

    & .MuiTabs-root {
      border-right: none;
    }
  `,
  notes_block: css`
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0 1.5rem 2rem 1.5rem;
    & .MuiInputBase-root {
      background-color: white;
    }
    & .MuiButtonBase-root {
      padding: 0 0.5rem;
      height: 2rem;
      margin: 0 0 18px 8px;
    }
  `,
  formArea: {
    height: "650px",
    maxHeight: "650px",
    overflow: "auto",
    p: 3,
  },
};